const state = {
    data: [],
    orderables: [
    {
      title: 'Nome',
      name: 'arquivo_nome'
    },
    {
      title: 'Cadastrado em',
      name: 'created_at'
    }
  ],
  filterGroups: [{
    name: 'Arquivo',
    filters: [{
        title: 'Nome',
        name: 'arquivo_nome',
        type: 'string'
      },
      {
        title: 'Cadastrado em',
        name: 'created_at',
        type: 'datetime'
      }
    ]
  }]
  };
  
  const mutations = {
    SET_PENDENTES: (state, payload) => {
      state.data = payload;
    },
    ADD_PENDENTES: (state, payload) => {
      state.data.push(...payload);
    },
  };
  
  const actions = {
    setPendetes: (context, payload) => {
      context.commit('SET_PENDENTES', payload);
    },
  };
  export default {
    state,
    mutations,
    actions
  };